
import { useState, useEffect } from 'react';
import { initialFinanceRecords } from '../mocks/financeRecords';
import type { FinanceRecord } from '../mocks/financeRecords';

export type { FinanceRecord };

const STORAGE_KEY = 'finance_records';

function loadRecords(): FinanceRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as FinanceRecord[];
  } catch {
    // ignore
  }
  return initialFinanceRecords;
}

function saveRecords(records: FinanceRecord[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

export function addFinanceRecord(record: FinanceRecord) {
  const records = loadRecords();
  records.unshift(record);
  saveRecords(records);
}

export function updateFinanceRecord(updated: FinanceRecord) {
  const records = loadRecords();
  const idx = records.findIndex(r => r.id === updated.id);
  if (idx !== -1) records[idx] = updated;
  saveRecords(records);
}

export function useFinanceRecords() {
  const [records, setRecords] = useState<FinanceRecord[]>(loadRecords);

  useEffect(() => {
    const handler = () => setRecords(loadRecords());
    window.addEventListener('finance_updated', handler);
    return () => window.removeEventListener('finance_updated', handler);
  }, []);

  const refresh = () => setRecords(loadRecords());

  const save = (updated: FinanceRecord) => {
    updateFinanceRecord(updated);
    setRecords(loadRecords());
  };

  return { records, setRecords, refresh, save };
}

export function dispatchFinanceUpdate() {
  window.dispatchEvent(new Event('finance_updated'));
}
